module.exports = __webpack_public_path__ + "img/CellCycle-MELA_GSE185386.72eebd9f.png";